"use client";
import { jsx as o } from "react/jsx-runtime";
import { memo as e } from "react";
import t from "../components/Icon/SvgIcon.js";
const i = (l) => /* @__PURE__ */ o(
  t,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...l,
    children: /* @__PURE__ */ o(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m16.422 8.827-1.984 1.877.468 2.648c.043.24-.216.424-.439.31l-2.453-1.251-2.452 1.25c-.223.115-.483-.07-.44-.309l.468-2.648-1.984-1.877c-.18-.17-.08-.465.168-.5l2.742-.387 1.226-2.409a.307.307 0 0 1 .544 0l1.226 2.41 2.742.385c.249.036.348.332.168.501M12.024 1.94C7.62 1.94 4.022 5.404 4 9.672a7.7 7.7 0 0 0 1.457 4.436c.03.058.071.13.114.163l5.249 6.756a1.588 1.588 0 0 0 2.376.032l5.204-6.723c.074-.073.167-.162.205-.25a7.57 7.57 0 0 0 1.423-4.422c0-4.259-3.59-7.725-8.004-7.725Z",
        clipRule: "evenodd"
      }
    )
  }
), n = e(i);
export {
  n as LocationFavoriteFilled,
  n as default
};
